import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./ForgotPassword.html';
import styles from './ForgotPassword-hashed.scss';
import AuthenticationService from 'plugin?auth-type!gw-portals-auth-js/AuthenticationService';
import ComponentUtil from 'gw-portals-util-js/ComponentUtil';

// VARS
const hashedTemplate = cssUtil.hashTemplate(template, styles);

// EXPORT

export default {
    template: hashedTemplate,
    controller: [
        'auth.AuthLoginModal', '$scope', '$state', 'oAuth',
        function (AuthLoginModal, $scope, $state, oAuth) {
            this.$onInit = function () {
                // VARS
                const $ctrl = this;
                const authenticationService = AuthenticationService(oAuth);

                $ctrl.isForgotReqInProgress = false;// animation

                // METHODS
                const setCtrlParam = ComponentUtil.setCtrlParam($ctrl, $scope);

                function setError(value) {
                    setCtrlParam('forgotPasswordError', value);
                }

                // Default model attr required by gw-pl-inline-ctrl-group directive
                $ctrl.email = {
                    aspects: {
                        get valid() {
                            const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/;
                            return regex.test($ctrl.email.value);
                        }
                    }
                };

                $ctrl.send = () => {

                    if (!$ctrl.email.aspects.valid) {
                        setError('fieldIncorrect');
                        return;
                    }

                    setCtrlParam('isForgotReqInProgress', true);// animation
                    authenticationService.forgotPassword($ctrl.email.value)
                        .then(() => {
                            setCtrlParam('isForgotReqInProgress', false);// animation
                            setCtrlParam('status', 'EMAIL_SENT');
                        })
                        .catch(err => {
                            switch (err.error) {
                                case authenticationService.ERRORS.tokens.emailNotFound:
                                    setCtrlParam('status', 'EMAIL_NOT_FOUND');
                                    break;
                                default:
                                    setCtrlParam('status', 'INVALID_ATTEMPT');
                                    break;
                            }
                        });
                };

                $ctrl.backToSignIn = () => {
                    $state.go('authLogin');
                };
            };
        }]
};